import { TranslateFunction } from 'react-localize-redux';

import { type SettingsMenuItem } from '@fd/ui/List/SettingsList';

import { ItemMetaData } from '../menuItemsConfig';

const extractValidItems = (
  subItems: ItemMetaData['subItems'] | ItemMetaData['subDrawerItems'],
  translate: TranslateFunction
) =>
  subItems
    ?.filter((sub) => sub.path && !sub.hidden)
    .map((sub) => ({
      title: translate(sub.title) as string,
      // Untranslated key, so a consumer can map the item to its sidebar icon.
      titleKey: sub.title,
      path: sub.path,
      icon: sub.icon,
      searchAlias: sub.searchAlias,
      permissions: sub.permissions,
      viewId: sub.viewId,
      exemptFromViewConfiguration: sub.exemptFromViewConfiguration,
    })) ?? [];

export type flattenedMenuItem = ReturnType<typeof flattenMenuItems>;
export type PropertyItem = Omit<ItemMetaData, 'title'> & {
  title: string;
  noTranslate: boolean;
};
export const flattenMenuItems = (
  items: (ItemMetaData | SettingsMenuItem | PropertyItem)[],
  translate: TranslateFunction
) => {
  return items.flatMap((item) => {
    const topLevel =
      item?.path && !item.subItems && !item.subDrawerItems && !item.hidden
        ? [
            {
              title:
                'noTranslate' in item && item.noTranslate
                  ? item.title
                  : (translate(item.title as TranslationId) as string),
              titleKey:
                'noTranslate' in item && item.noTranslate
                  ? undefined
                  : (item.title as TranslationId),
              path: item.path,
              icon: item.icon,
              searchAlias: item.searchAlias ?? [],
              propertyId: 'propertyId' in item ? item.propertyId : '',
              propertyName: 'propertyName' in item ? item.propertyName : '',
              permissions: item.permissions,
              viewId: 'viewId' in item ? item.viewId : undefined,
              exemptFromViewConfiguration:
                'exemptFromViewConfiguration' in item
                  ? item.exemptFromViewConfiguration
                  : undefined,
              salesChannelType: 'salesChannelType' in item ? item.salesChannelType : '',
              salesChannelName: 'salesChannelName' in item ? item.salesChannelName : '',
              salesChannelId: 'salesChannelId' in item ? item.salesChannelId : '',
            },
          ]
        : [];

    return [
      ...topLevel,
      ...extractValidItems(item?.subItems, translate),
      ...extractValidItems(item?.subDrawerItems, translate),
    ];
  });
};
